import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

/**
 * Sends message to Designer App that Canvas App iframe is rendered
 */
export const setCanvasAppReady = () => {
  const message = {method: 'canvasAppReady'};
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
